import Layout from "@/layout";

const contractManagementRouter = {
  path: "/contractManagement",
  component: Layout,
  redirect: "/contractManagement/purchase",
  name: "contractManagement",
  meta: {
    title: "合同管理",
    icon: "clipboard"
  },
  children: [
    {
      path: "purchase",
      component: () => import("@/views/contractManagement/purchase/index"),
      name: "purchase",
      meta: { title: "购买管理", icon: "" }
    },
    {
      path: "templates",
      component: () => import("@/views/contractManagement/templates/index"),
      name: "templates",
      meta: { title: "模板管理", icon: "" }
    },
    {
      path: "order",
      component: () => import("@/views/contractManagement/order/index"),
      name: "Order",
      meta: { title: "订单管理" }
    },
    {
      path: "create/:id?",
      component: () => import("@/views/contractManagement/order/create/index"),
      name: "OrderCreat",
      meta: {
        title: "创建/编辑订单",
        noCache: true,
        activeMenu: `/contractManagement/order`,
        parentPath: "/contractManagement/order"
      },
      hidden: true
    },
    {
      path: "contract/:id?",
      component: () =>
        import("@/views/contractManagement/order/contract/create"),
      name: "MemPlanCreat",
      meta: {
        title: "电子合同",
        noCache: true,
        activeMenu: `/contractManagement/order`,
        parentPath: "/contractManagement/order"
      },
      hidden: true
    },
    {
      path: "payments/:id?",
      component: () =>
        import("@/views/contractManagement/order/payments/index"),
      name: "payments",
      meta: {
        title: "合同收支",
        noCache: true,
        activeMenu: `/contractManagement/order`,
        parentPath: "/contractManagement/order"
      },
      hidden: true
    }
  ]
};

export default contractManagementRouter;
